"use strict";
/*
Copyright 2021 Splunk Inc.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplunkFetchInstrumentation = void 0;
const core_1 = require("@opentelemetry/core");
const instrumentation_fetch_1 = require("@opentelemetry/instrumentation-fetch");
const servertiming_1 = require("./servertiming");
class SplunkFetchInstrumentation extends instrumentation_fetch_1.FetchInstrumentation {
    constructor(config = {}) {
        const origCustomAttrs = config.applyCustomAttributesOnSpan;
        config.applyCustomAttributesOnSpan = function (span, request, result) {
            if (span && result instanceof Response && result.headers) {
                const st = result.headers.get('Server-Timing');
                if (st) {
                    (0, servertiming_1.captureTraceParent)(st, span);
                }
            }
            if (origCustomAttrs) {
                origCustomAttrs(span, request, result);
            }
        };
        super(config);
        const _superPrepareSpanData = this._prepareSpanData.bind(this);
        this._prepareSpanData = (spanUrl) => {
            // Fix: PerformanceObserver feature detection is broken and crashes in IE
            // Is fixed in 0.29.0 but contrib isn't updated yet
            if (typeof PerformanceObserver !== 'function') {
                const startTime = (0, core_1.hrTime)();
                const entries = [];
                return { entries, startTime, spanUrl };
            }
            return _superPrepareSpanData(spanUrl);
        };
    }
    enable() {
        // Don't attempt in browsers where there's no fetch API
        if (!window.fetch) {
            return;
        }
        super.enable();
    }
}
exports.SplunkFetchInstrumentation = SplunkFetchInstrumentation;
//# sourceMappingURL=SplunkFetchInstrumentation.js.map